import { render } from "./linkPopper.vue?vue&type=template&id=47ed9a42"
import script from "./linkPopper.vue?vue&type=script&lang=js"
export * from "./linkPopper.vue?vue&type=script&lang=js"

import "./linkPopper.vue?vue&type=style&index=0&id=47ed9a42&lang=css"

import exportComponent from "/tmp/build_b6f5290c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__